import React from 'react';

import { translate as t } from '../../lib/I18n';

import Icon from '../general/Icon';


function EmptyBasket () {
    return (
        <div className="basket--empty vertical-align-parent padding-top padding-bottom bg--light-grey">
            <div className="confirmation vertical-align text-center">
                <Icon icon="error margin-bottom--sm otrl-xl" />
                <p className="alert-danger no-margin text-weight--normal">{ t('basket.empty') }</p>
            </div>
        </div>
    );
}


export default EmptyBasket;



// WEBPACK FOOTER //
// ./src/components/checkout/EmptyBasket.js